import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Badge.module.css';

export default function Badge({ color = 'gray', label = '' }) {
  return (
    <div
      className={cx(styles.badge, {
        [styles.red]: color === 'red',
        [styles.green]: color === 'green',
        [styles.yellow]: color === 'yellow',
        [styles.gray]: color === 'gray',
      })}
    >
      {label}
    </div>
  );
}

Badge.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
};
